import { useEffect } from "react";
import { useGlobalPluginInfo } from "../../../context/pluginInfoContext";
import kebabCase from "lodash/kebabCase";
import { getPluginFolderName } from "../../../utils/getPluginFolderName";
import { useFileStore } from "../../../strore/useFileStore";

const FeedbackPhp = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store.feedbackPhp);
    const { advancedItem, pluginInfo, crm, pluginType } = useGlobalPluginInfo();
    const { constantPrefix, baseNamespace, functionPrefix } = advancedItem;
    const { pluginAuthor, pluginAuthorEmail, pluginTextDomain, pluginClassPrefix, pluginName } =
        pluginInfo;
    const rootFolderName = getPluginFolderName(pluginName);

    useEffect(() => {
        let value = `<?php
${
    pluginType === "adminify_module"
        ? `namespace WPAdminify\\Modules\\${baseNamespace}\\Inc\\Classes;

use WPAdminify\\Modules\\${baseNamespace}\\Inc\\Classes\\Notifications\\Base\\User_Data;`
        : `namespace ${baseNamespace}\\Inc\\Classes;

use ${baseNamespace}\\Inc\\Classes\\Notifications\\Base\\User_Data;`
}

// No, Direct access Sir !!!
if ( ! defined( 'ABSPATH' ) ) {
	exit;
}

/**
 * Feedback
 *
 * @author ${pluginAuthor} <${pluginAuthorEmail}>
 */
class Feedback {

    use User_Data;

	/**
	 * Construct Method
	 *
	 * @return void
	 * @author ${pluginAuthor} <${pluginAuthorEmail}>
	 */
    public function __construct(){
        add_action( 'admin_enqueue_scripts' , [ $this,'admin_suvery_scripts'] );
        add_action( 'admin_footer' , [ $this , 'deactivation_footer' ] );
        add_action( 'wp_ajax_${functionPrefix}_deactivation_survey', array( $this, '${functionPrefix}_deactivation_survey' ) );

    }


    public function proceed(){

        global $current_screen;
        if(
            isset($current_screen->parent_file)
            && $current_screen->parent_file == 'plugins.php'
            && isset($current_screen->id)
            && $current_screen->id == 'plugins'
        ){
           return true;
        }
        return false;

    }

    public function admin_suvery_scripts($handle){
        if('plugins.php' === $handle){
            wp_enqueue_style( '${rootFolderName}-survey' , ${constantPrefix}_ASSETS . 'css/${rootFolderName}-survey.css' );
        }
    }

    /**
     * Deactivation Survey
     */
    public function ${functionPrefix}_deactivation_survey(){
        check_ajax_referer( '${functionPrefix}_deactivation_nonce' );

        $deactivation_reason  = ! empty( $_POST['deactivation_reason'] ) ? sanitize_text_field( wp_unslash( $_POST['deactivation_reason'] ) ) : '';

        if( empty( $deactivation_reason )){
            return;
        }

        $email = get_bloginfo( 'admin_email' );
        $author_obj = get_user_by( 'email', $email );
        $user_id    = $author_obj->ID;
        $full_name  = $author_obj->display_name;

        $response = $this->get_collect_data( $user_id, array(
            'first_name'              => $full_name,
            'email'                   => $email,
            'deactivation_reason'     => $deactivation_reason,
        ) );

        return $response;
    }


    public function get_survey_questions(){

        return [
			'no_longer_needed' => [
				'title' => esc_html__( 'I no longer need the plugin', '${pluginTextDomain}' ),
				'input_placeholder' => '',
			],
			'found_a_better_plugin' => [
				'title' => esc_html__( 'I found a better plugin', '${pluginTextDomain}' ),
				'input_placeholder' => esc_html__( 'Please share which plugin', '${pluginTextDomain}' ),
			],
			'couldnt_get_the_plugin_to_work' => [
				'title' => esc_html__( 'I couldn\\'t get the plugin to work', '${pluginTextDomain}' ),
				'input_placeholder' => '',
			],
			'temporary_deactivation' => [
				'title' => esc_html__( 'It\\'s a temporary deactivation', '${pluginTextDomain}' ),
				'input_placeholder' => '',
			],
			'${functionPrefix}_pro' => [
				'title' => sprintf( esc_html__( 'I have %1$s Pro', '${pluginTextDomain}' ), ${constantPrefix} ),
				'input_placeholder' => '',
				'alert' => sprintf( esc_html__( 'Wait! Don\\'t deactivate %1$s. You have to activate both %1$s and %1$s Pro in order for the plugin to work.', '${pluginTextDomain}' ), ${constantPrefix} ),
			],
			'need_better_design' => [
				'title' => esc_html__( 'I need better design and presets', '${pluginTextDomain}' ),
				'input_placeholder' => esc_html__( 'Let us know your thoughts', '${pluginTextDomain}' ),
			],
            'other' => [
				'title' => esc_html__( 'Other', '${pluginTextDomain}' ),
				'input_placeholder' => esc_html__( 'Please share the reason', '${pluginTextDomain}' ),
			],
		];
    }


        /**
         * Deactivation Footer
         */
        public function deactivation_footer(){

        if(!$this->proceed()){
            return;
        }

        ?>
        <div class="${pluginClassPrefix}-deactivate-survey-overlay" id="${pluginClassPrefix}-deactivate-survey-overlay"></div>
        <div class="${pluginClassPrefix}-deactivate-survey-modal" id="${pluginClassPrefix}-deactivate-survey-modal">
            <header>
                <div class="${pluginClassPrefix}-deactivate-survey-header">
                    <img src="<?php echo esc_url(${constantPrefix}_IMAGES . '/menu-icon.png'); ?>" />
                    <h3><?php echo wp_sprintf( '%1$s %2$s', ${constantPrefix}, esc_html__( '- Feedback', '${pluginTextDomain}' ) ); ?></h3>
                </div>
            </header>
            <div class="${pluginClassPrefix}-deactivate-info">
                <?php echo wp_sprintf( '%1$s %2$s', esc_html__( 'If you have a moment, please share why you are deactivating', '${pluginTextDomain}' ), ${constantPrefix} ); ?>
            </div>
            <div class="${pluginClassPrefix}-deactivate-content-wrapper">
                <form action="#" class="${pluginClassPrefix}-deactivate-form-wrapper">
                    <?php foreach($this->get_survey_questions() as $reason_key => $reason){ ?>
                        <div class="${pluginClassPrefix}-deactivate-input-wrapper">
                            <input id="${pluginClassPrefix}-deactivate-feedback-<?php echo esc_attr($reason_key); ?>" class="${pluginClassPrefix}-deactivate-feedback-dialog-input" type="radio" name="reason_key" value="<?php echo $reason_key; ?>">
                            <label for="${pluginClassPrefix}-deactivate-feedback-<?php echo esc_attr($reason_key); ?>" class="${pluginClassPrefix}-deactivate-feedback-dialog-label"><?php echo esc_html( $reason['title'] ); ?></label>
							<?php if ( ! empty( $reason['input_placeholder'] ) ) : ?>
								<input class="${pluginClassPrefix}-deactivate-feedback-text" type="text" name="reason_<?php echo esc_attr( $reason_key ); ?>" placeholder="<?php echo esc_attr( $reason['input_placeholder'] ); ?>" />
							<?php endif; ?>
                        </div>
                    <?php } ?>
                    <div class="${pluginClassPrefix}-deactivate-footer">
                        <button id="${pluginClassPrefix}-dialog-lightbox-submit" class="${pluginClassPrefix}-dialog-lightbox-submit"><?php echo esc_html__( 'Submit &amp; Deactivate', '${pluginTextDomain}' ); ?></button>
                        <button id="${pluginClassPrefix}-dialog-lightbox-skip" class="${pluginClassPrefix}-dialog-lightbox-skip"><?php echo esc_html__( 'Skip & Deactivate', '${pluginTextDomain}' ); ?></button>
                    </div>
                </form>
            </div>
        </div>

        <script>
            var deactivate_url = '#';

            jQuery(document).on('click', '#deactivate-${kebabCase(pluginName)}', function(e) {
                e.preventDefault();
                deactivate_url = e.target.href;
                jQuery('#${pluginClassPrefix}-deactivate-survey-overlay').addClass('${pluginClassPrefix}-deactivate-survey-is-visible');
                jQuery('#${pluginClassPrefix}-deactivate-survey-modal').addClass('${pluginClassPrefix}-deactivate-survey-is-visible');
            });

            jQuery('#${pluginClassPrefix}-dialog-lightbox-skip').on('click', function (e) {
                e.preventDefault();
                window.location.replace(deactivate_url);
            });


            jQuery(document).on('click', '#${pluginClassPrefix}-dialog-lightbox-submit', async function(e) {
                e.preventDefault();

                jQuery('#${pluginClassPrefix}-dialog-lightbox-submit').addClass('${pluginClassPrefix}-loading');

                var $dialogModal = jQuery('.${pluginClassPrefix}-deactivate-input-wrapper'),
                    radioSelector = '.${pluginClassPrefix}-deactivate-feedback-dialog-input';
                $dialogModal.find(radioSelector).on('change', function () {
                    $dialogModal.attr('data-feedback-selected', jQuery(this).val());
                });
                $dialogModal.find(radioSelector + ':checked').trigger('change');


                // Reasons for deactivation
                var deactivation_reason = '';
                var reasonData = jQuery('.${pluginClassPrefix}-deactivate-form-wrapper').serializeArray();

                jQuery.each(reasonData, function (reason_index, reason_value) {
                    if ('reason_key' == reason_value.name && reason_value.value != '') {
                        const reason_input_id = '#${pluginClassPrefix}-deactivate-feedback-' + reason_value.value,
                            reason_title = jQuery(reason_input_id).siblings('label').text(),
                            reason_placeholder_input = jQuery(reason_input_id).siblings('input').val(),
                            format_title_with_key = reason_value.value + ' - '  + reason_placeholder_input,
                            format_title = reason_title + ' - '  + reason_placeholder_input;

                        deactivation_reason = reason_value.value;

                        if ('found_a_better_plugin' == reason_value.value ) {
                            deactivation_reason = format_title_with_key;
                        }

                        if ('need_better_design' == reason_value.value ) {
                            deactivation_reason = format_title_with_key;
                        }

                        if ('other' == reason_value.value) {
                            deactivation_reason = format_title_with_key;
                        }
                    }
                });

                await jQuery.ajax({
                        url: '<?php echo esc_url( admin_url( 'admin-ajax.php' ) ); ?>',
                        method: 'POST',
                        // crossDomain: true,
                        async: true,
                        // dataType: 'jsonp',
                        data: {
                            action: '${functionPrefix}_deactivation_survey',
                            _wpnonce: '<?php echo esc_js( wp_create_nonce( '${functionPrefix}_deactivation_nonce' ) ); ?>',
                            deactivation_reason: deactivation_reason
                        },
                        success:function(response){
                            window.location.replace(deactivate_url);
                        }
                });
                return true;
            });

            jQuery('#${pluginClassPrefix}-deactivate-survey-overlay').on('click', function () {
                jQuery('#${pluginClassPrefix}-deactivate-survey-overlay').removeClass('${pluginClassPrefix}-deactivate-survey-is-visible');
                jQuery('#${pluginClassPrefix}-deactivate-survey-modal').removeClass('${pluginClassPrefix}-deactivate-survey-is-visible');
            });
        </script>
        <?php
    }

}`;
        setStore({ feedbackPhp: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        baseNamespace,
        constantPrefix,
        crm,
        functionPrefix,
        pluginAuthor,
        pluginAuthorEmail,
        pluginClassPrefix,
        pluginName,
        pluginTextDomain,
        pluginType,
    ]);
    return null;
};

export default FeedbackPhp;
